import TimerIcon from '@mui/icons-material/Timer';
import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDeviceStore } from '../../stores/deviceStore';

function format(elapsedSeconds) {
  const hh = String(Math.floor(elapsedSeconds / 3600)).padStart(2, '0');
  const mm = String(Math.floor((elapsedSeconds % 3600) / 60)).padStart(2, '0');
  const ss = String(elapsedSeconds % 60).padStart(2, '0');
  return `${hh}:${mm}:${ss}`;
}

/**
 * Live measurement-duration counter. Counts up while a measurement is running
 * (connection 'connected' with a start timestamp) and stops/resets when the
 * measurement ends. The persisted duration of a finished recording is shown in
 * FileInfo instead.
 */
export const MeasurementTimer = () => {
  const startedAt = useDeviceStore((state) => state.measurementStartedAt);
  const isConnected = useDeviceStore((state) => state.connectionState === 'connected');
  const running = isConnected && startedAt !== null;

  const [elapsed, setElapsed] = useState(0);

  useEffect(() => {
    if (!running || startedAt === null) {
      setElapsed(0);
      return;
    }
    const tick = () => setElapsed(Math.max(0, Math.floor((Date.now() - startedAt) / 1000)));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [running, startedAt]);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
      <TimerIcon sx={{ color: running ? '#394b57' : '#A9B6BC', fontSize: '14px' }} />
      <Typography
        sx={{
          fontFamily: 'Inter',
          fontSize: '12px',
          fontWeight: 400,
          color: running ? '#394b57' : '#A9B6BC',
          minWidth: 72,
        }}
      >
        {format(elapsed)}
      </Typography>
    </Box>
  );
};
